































import Vue from "vue";
import Fieldset, { Field } from "./Fieldset.vue";

export interface CollapseField {
  fields: Field[];
  title?: String;
}

export default Vue.extend({
  name: "FieldCollapse",
  components: { Fieldset },
  props: {
    fields: {
      type: Array as () => CollapseField[],
      required: true,
    },
    data: {
      type: [Object, Array],
      required: true,
    },
    allOpen: {
      type: Boolean,
      default: false,
    },
  },
  data: function () {
    return {
      isOpen: -1,
    };
  },
});
